import styled from 'styled-components';
import { FieldContainerWithLabel } from 'components';
import { Control, Controller, ControllerRenderProps } from 'react-hook-form';

type FormFields = {
  sendWithUniqueIdentifier: boolean;
};
import {
  RadioButtonContainer,
  RadioButtonSelectIndicator,
} from 'components/RadioGroup/RadioButton';

const RadioTitle = styled.p`
  font-size: 1rem;
  font-weight: 600;
  padding-bottom: 0.5rem;
`;

const RadioText = styled.span<{ isDisabled: boolean }>`
  font-size: 1rem;
  font-weight: 400;
  margin-bottom: 0;
  color: ${({ isDisabled, theme }) => (isDisabled ? theme.darkGrey : theme.baseBlack)};
`;

interface MessageIdentificationRadioProps {
  isDisabled: boolean;
  control: Control<FormFields>;
}

export const MessageIdentificationRadio: React.FC<MessageIdentificationRadioProps> = ({
  isDisabled,
  control,
}) => {
  const handleChange = (
    field: ControllerRenderProps<FormFields, 'sendWithUniqueIdentifier'>,
    value: boolean,
  ) => {
    field.onChange(value);
  };
  return (
    <FieldContainerWithLabel isDisabled={isDisabled}>
      <RadioTitle>Message identification and versioning</RadioTitle>
      <Controller<FormFields>
        name="sendWithUniqueIdentifier"
        control={control}
        defaultValue={false}
        render={({ field }) => (
          <div>
            <RadioButtonContainer>
              <input
                type="radio"
                value="false"
                checked={field.value === false}
                onChange={() => handleChange(field, false)}
                disabled={isDisabled}
              />
              <RadioButtonSelectIndicator />
              <RadioText isDisabled={isDisabled}>
                Keep identification, increment version (Edig@s standard)
              </RadioText>
            </RadioButtonContainer>
            <RadioButtonContainer>
              <input
                type="radio"
                value="true"
                checked={field.value === true}
                onChange={() => field.onChange(true)}
                disabled={isDisabled}
              />
              <RadioButtonSelectIndicator />
              <RadioText isDisabled={isDisabled}>
                New unique identification with each version, version set to 1
              </RadioText>
            </RadioButtonContainer>
          </div>
        )}
      />
    </FieldContainerWithLabel>
  );
};
